module.exports = __webpack_public_path__ + "img/header-logo-2.db4bf403.png";